<div class="box left">
  @if (isBrian) {
    <h3>{{ "firstActionGuideDialog.synchronizeHeadline" | translate }}</h3>
    <evc-nav-button [mat-dialog-close]="'synchronize'" type="tertiary" size="lg">
      {{ "firstActionGuideDialog.synchronize" | translate }}
    </evc-nav-button>
  } @else {
    <h3>{{ "firstActionGuideDialog.downloadHeadline" | translate }}</h3>
    <evc-nav-button [mat-dialog-close]="'download'" type="tertiary" size="lg">
      {{ "firstActionGuideDialog.download" | translate }}
    </evc-nav-button>
  }
</div>
<div class="box">
  <h3>{{ "firstActionGuideDialog.importHeadline" | translate }}</h3>
  <evc-nav-button [mat-dialog-close]="'upload'" type="tertiary" size="lg">
    {{ getUploadOrSaveText() }}
  </evc-nav-button>
</div>
